let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3fuR9"), load("gZU54"), load("2bqSD"), load("6ScwG")]).then(() => parcelRequire('bHXNj'));